export default __webpack_public_path__ + "static/media/mheaderEvent-min.f342c69a.jpg";